import { Radio, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { SelectableButton } from "~/modules/app/components/SelectableButton";

import { FeatureCreateOptionOther, FeatureGeometryType } from "../types";

type Props = {
    draftSelectedOption: Partial<FeatureCreateOptionOther>;
    onUpdate: (option: Partial<FeatureCreateOptionOther>) => void;
};

const options: { key: FeatureGeometryType; label: string }[] = [
    {
        key: "Polygon",
        label: "mapEditorFeatureCreateOptions.labelPolygon",
    },
    {
        key: "LineString",
        label: "mapEditorFeatureCreateOptions.labelLine",
    },
    {
        key: "Point",
        label: "mapEditorFeatureCreateOptions.labelPoint",
    },
];

export default function OtherSection({ draftSelectedOption, onUpdate }: Props) {
    const { t } = useTranslation("mapEditor");

    return (
        <Stack rowGap={1}>
            <Typography variant="subtitle2">{t("mapEditorFeatureCreateDialog.plannerAreaSection.title")}</Typography>
            <Stack direction="row" columnGap={1}>
                {options.map(({ key, label }) => (
                    <SelectableButton
                        key={key}
                        selected={draftSelectedOption.geometryType === key}
                        sx={{ flexGrow: 1, justifyContent: "start", padding: 1, columnGap: 1 }}
                        onClick={() =>
                            onUpdate({
                                ...draftSelectedOption,
                                geometryType: key,
                            })
                        }
                    >
                        <Radio sx={{ padding: 0 }} checked={draftSelectedOption.geometryType === key} />
                        <Typography>{t(label)}</Typography>
                    </SelectableButton>
                ))}
            </Stack>
        </Stack>
    );
}
